// eslint-disable-next-line no-restricted-imports
import { Decimal } from 'decimal.js';

export function dec(value: Decimal.Value): Decimal {
  return new Decimal(value);
}

export const ZERO = dec('0');

export { Decimal };
